import { IS_MOBILE, IS_SIMULATION } from '@utilities/browser';

type BeforeInstallPromptEvent = Event & { prompt: () => Promise<void> };

let deferredPrompt: BeforeInstallPromptEvent = null;

const appPanel = document.querySelector('.js-app-panel');

const openPanel = () => {
  appPanel.classList.add('app-banner--open');
};

const closePanel = () => {
  appPanel.classList.remove('app-banner--open');
};

const init = () => {
  if (!appPanel) return;

  if (!IS_MOBILE) {
    closePanel();
    return;
  }

  window.addEventListener('beforeinstallprompt', (e: BeforeInstallPromptEvent) => {
    e.preventDefault();
    if (deferredPrompt) return;
    deferredPrompt = e;

    openPanel();
  });

  const appButton = appPanel.querySelector<HTMLPkButtonElement>('.js-app-button');
  appButton.addEventListener('pkClick', async () => {
    await deferredPrompt?.prompt();
    closePanel();
  });

  const appClose = appPanel.querySelector<HTMLPkButtonElement>('.js-app-close');
  appClose.addEventListener('pkClick', () => {
    closePanel();
  });
};

init();

// Open the panel if we are in simulation mode
if (IS_SIMULATION && appPanel) {
  openPanel();
}
